import { render, staticRenderFns } from "./dlgSender.vue?vue&type=template&id=1ce8bd5f&"
import script from "./dlgSender.vue?vue&type=script&lang=js&"
export * from "./dlgSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports